import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const MerchandiserInvoicingStatuses = {
    AllCharges: {
        key: "AllCharges",
        title: "All Charges",
        value: -1,
        icon: null,
        color: "transparent"
    },
    NotApprovedYet: {
        key: "NotApprovedYet",
        title: "Not Approved Yet",
        value: 0,
        icon: <FontAwesomeIcon icon="ban" title="Not Approved Yet" size="lg" />,
        color: "#990000"
    },
    ApprovedAutomatically: {
        key: "ApprovedAutomatically",
        title: "Approved Automatically",
        value: 1,
        icon: <FontAwesomeIcon icon={["fas", "thumbs-up"]} title="Approved Automatically" size="lg" />,
        color: "#009e0f"
    },
    ApprovedByManager: {
        key: "ApprovedByManager",
        title: "Approved By Manager",
        value: 2,
        icon: <FontAwesomeIcon icon={["far", "thumbs-up"]} title="Approved By Manager" size="lg" />,
        color: "#009e0f"
    },
    RejectedByManager: {
        key: "RejectedByManager",
        title: "Rejected By Manager",
        value: 3,
        icon: <FontAwesomeIcon icon={["far", "thumbs-down"]} title="Rejected By Manager" size="lg" />,
        color: "#990000"
    },
    AllApproved: {
        key: "AllApproved",
        title: "All Approved",
        value: 4,
        icon: null,
        color: "transparent"
    },
};

export default MerchandiserInvoicingStatuses;
